(function () {
  'use strict';

  var SECTION_SELECTOR = '.wb-frag';

  function initFrag(container) {
    var track   = container.querySelector('.wb-frag__track');
    var viewport = container.querySelector('.wb-frag__viewport');
    var mode    = container.dataset.mode;

    if (!track || !viewport) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (mode === 'auto') {
      if (prefersReduced) {
        viewport.style.overflowX = 'auto';
        return;
      }

      var originalHTML = track.innerHTML;
      track.innerHTML = originalHTML + originalHTML + originalHTML;

      var scrollPos  = 0;
      var isHovered  = false;
      var speed      = 0.6;
      var rafId      = null;
      var resetAt    = track.scrollWidth / 3;

      function animate() {
        if (!isHovered) {
          scrollPos += speed;
          if (scrollPos >= resetAt) {
            scrollPos = 0;
          }
          track.style.transform = 'translateX(-' + scrollPos + 'px)';
        }
        rafId = requestAnimationFrame(animate);
      }

      function pause() { isHovered = true; }
      function resume() { isHovered = false; }

      track.addEventListener('mouseenter', pause);
      track.addEventListener('mouseleave', resume);
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('touchend', resume, { passive: true });

      rafId = requestAnimationFrame(animate);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          cancelAnimationFrame(rafId);
        } else {
          rafId = requestAnimationFrame(animate);
        }
      });
    }
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initFrag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section) initFrag(section);
  });

})();